export const SpecialPricingRulesIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 15.7508C10.123 15.7508 8.03102 15.7491 6.00857 15.7491C4.34835 15.7491 3.00219 14.402 3.00379 12.7418C3.00627 10.1525 3.00627 7.84918 3.00379 5.25987C3.00219 3.59965 4.34842 2.25277 6.00864 2.25391C8.00286 2.25527 9.9971 2.25527 11.9913 2.25391C13.6515 2.25277 14.9977 3.59942 14.9974 5.25964C14.9969 7.73503 14.9999 9.93769 14.9999 12.7508M12 15.7508V13.5008C12 13.0866 12.3358 12.7508 12.75 12.7508H14.9999M12 15.7508L14.9999 12.7508M6.75002 5.25082L7.50002 6.00082M6.18676 7.50083L8.06023 5.62739C8.06023 5.62739 8.48727 5.11784 8.06023 4.69067C7.63319 4.26351 7.12349 4.69067 7.12349 4.69067L5.25002 6.56411V7.50083H6.18676Z"
        stroke="#05796B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
